export const CONSTANTS = {
  IMAGES_FIELD: "images",
  REQUIRED: "Required",
  DELETE: "delete",
  SUCCESS: "success",
  TITLE: "Title",
  NAME: "Name",
  ENTER_TITLE: "Enter title",
  IMAGE: "Image",
  ENTER_IMAGE: "Enter image",
  ENTER_NAME: "Enter name",
  EMAIL: "Email",
  CHANGE_PASSWORD: "Change password",
  LOG_OUT: "Log Out",
  OLD_PASSWORD: "Old password",
  PASSWORD: "Password",
  CURRENT_PASSWORD: "Current password",
  NEW_PASSWORD: "New password",
  CONFIRM_PASSWORD: "Confirm password",
  CANCEL: "Cancel",
  CONFIRM: "Confirm",
  SAVE: "Save",
  PASSWORD_CHANGE_SUCCESS: "Password changed successfully",
  EMAIL_VALIDATION_MESSAGE: "Please enter valid email",
  INVALID_PASSWORD_MESSAGE: "Invalid password",
  BACK_BUTTON: "Back",
  MAX_QUESTIONS_COUNT_MESSAGE:
    "The maximum question limit for the diagnostic quiz is set at 20.",
  MAX_QUESTIONS_COUNT: 20,
  CREATE: "Create",
  EDIT: "Edit",
  REMOVE: "Remove",
  VIMEO_SETTINGS: "Vimeo Settings",
  VIMEO_CLIENT_ID: "Vimeo Client Id",
  ENTER_VIMEO_CLIENT_ID: "Enter Vimeo Client Id",
  VIMEO_CLIENT_SECRET: "Vimeo Client Secret",
  ENTER_VIMEO_CLIENT_SECRET: "Enter Vimeo Client Secret",
  VIMEO_ACCESS_TOKEN: "Vimeo Access Token",
  ENTER_VIMEO_ACCESS_TOKEN: "Enter Vimeo Access Token",
  DELETE_VIMEO_SETTINGS: "Are you sure. You want to delete vimeo settings?",
  DELETE_TESTIMONIAL: "Are you sure. You want to delete testimonial?",
  COMMENT: "Comment",
  ENTER_COMMENT: "Enter Comment",
  STARS: "Stars",
  ENTER_STARS: "Enter Stars",
  WRITE_NOTES: "Write a Note",
  SEND: "Send",
  HERO_SECTION_CREATE_SUCCESS: "Hero section created successfully",
  HERO_SECTION_UPDATE_SUCCESS: "Hero section updated successfully",
  HERO_SECTION_DELETE_SUCCESS: "Hero section deleted successfully",
  HERO_SECTIONS_REORDER_SUCCESS: "Hero sections reordered successfully",
};

export const HELPER_TEXT =
  "If you want a word or phrase to be highlighted in color, please put it in {{ }}";

export const LOGIN_PAGE = {
  welcome: "Welcome to La Rochelle Admin!",
  sign_in_text: "Sign in to your account to get started",
  sign_in: "Sign in",
  email_address: "Email address",
  password: "Password",
  remember_me: "Remember me",
};

export const ACCESS_TOKEN = "access_token";

export const TABLE = {
  subject: "Subject",
  private_subject: "Private Subject",
  zero_value: 0,
  changed_page_count: 1,
  rtl: "rtl",
};

export const PASSWORD_MESSAGES = {
  minCharacter: "Password must be at least 8 characters long",
  lowerCase: "Password must contain at least one lowercase letter",
  upperCase: "Password must contain at least one uppercase letter",
  number: "Password must contain at least one number",
  password_match: "Passwords must match",
};

export const TABLE_PER_PAGE_COUNT = 15;
export const TABLE_MIN_PAGE = 1;
export const SEARCH_KEY = "search";

export const LOGOUT_MODAL = {
  title: "Log Out",
  message: "Are you sure you want to log out?",
};

export const TWO_FA = {
  setup_title: "Enable Two-Factor Authentication",
  verification_title: "Two-Factor Authentication",
  setup_description:
    "Scan the QR code below with your authenticator app (Google Authenticator, Authy, etc.)",
  verification_description:
    "Enter the 6-digit code from your authenticator app",
  secret_key_label: "Or enter this secret key manually:",
  scan_qr_instruction: "Scan this QR code with your authenticator app",
  check_authenticator: "Check your authenticator app for the current code",
  invalid_code: "Invalid or expired code. Please try again.",
  secret_copied: "Secret key copied to clipboard!",
  cancel: "Cancel",
  confirm: "Confirm",
  verifying: "Verifying...",
  after_setup_message:
    "After setting up your authenticator, enter the 6-digit code below:",
};

export const REQUEST_STATUSES = {
  loading: "loading",
  rejected: "rejected",
  solved: "solved",
  twoFARequired: "2fa_required",
};

export const META_DETAILS_PATHNAMES = {
  gallery: "gallery",
  home: "home",
  aboutUS: "about-us",
  menu: "menu",
  contactUs: "contact-us",
  privacyPolicy: "privacy-policy",
};

export const AVAILABLE_SERVICES = {
  PICKUP: "PICKUP",
  DELIVERY: "DELIVERY",
};

export const SPINNER_SIZE = 20;

export const EMPTY_MODAL = {
  open: false,
  mode: "add",
  id: null,
  name: "",
  nameTouched: false,
};
export const EMPTY_DELETE_DIALOG = { open: false, id: null, name: "" };

export const ICON_GRAY = "#4B5563";

export const WORKING_HOURS_DAYS = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun",
];

export const WORKING_HOURS_DAY_ALIASES = {
  Monday: "Mon",
  Tuesday: "Tue",
  Wednesday: "Wed",
  Thursday: "Thu",
  Friday: "Fri",
  Saturday: "Sat",
  Sunday: "Sun",
};

export const DEFAULT_WORKING_HOURS = [
  { fromDay: "Mon", toDay: "Sat", startTime: "7:00 AM", endTime: "4:00 PM" },
  { fromDay: "Sun", toDay: "Sun", startTime: "8:00 AM", endTime: "4:00 PM" },
];

const generateWorkingHoursTimes = () => {
  const times = [];
  for (let h = 0; h < 24; h++) {
    for (const m of [0, 30]) {
      const hour = h % 12 || 12;
      const period = h < 12 ? "AM" : "PM";
      times.push(`${hour}:${String(m).padStart(2, "0")} ${period}`);
    }
  }
  return times;
};
export const WORKING_HOURS_TIMES = generateWorkingHoursTimes();
